module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-3-1.74d3fc6c.png";